import React from 'react';
import { Box, Typography } from '@mui/material';

const PercentileChart = ({ rawScore, title = "Score", size = 80, showTitle = true }) => {
  const percentile = rawScore || 0;
  const radius = (size / 2) - 5; // Adjust radius based on size
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentile / 100) * circumference;
  const strokeWidth = Math.max(4, size / 13); // Scale stroke width with size

  const getPercentileColor = (value) => {
    if (value >= 90) return '#4CAF50'; // Green for A range
    if (value >= 80) return '#32CD32'; // Lime for B range
    if (value >= 70) return '#DAA520'; // Dark Yellow for C range
    if (value >= 60) return '#FF8C00'; // Orange for D range
    return '#FF0000'; // Red for F range
  };

  return (
    <Box sx={{ mb: showTitle ? 1 : 0, textAlign: 'center' }}>
      {showTitle && (
        <Typography variant="subtitle2" color="primary.main" fontWeight="bold" sx={{ mb: 0.5, fontSize: '0.8rem' }}>
          {title}
        </Typography>
      )}
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#E0E0E0"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={getPercentileColor(percentile)}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 0.5s ease' }}
          />
        </svg>
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}>
          <Typography variant="body2" fontWeight="bold" sx={{ 
            color: getPercentileColor(percentile),
            fontSize: size < 60 ? '0.7rem' : '0.8rem'
          }}>
            {rawScore ? `${rawScore}` : 'N/A'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PercentileChart;